(() => {
  const story = document.querySelector('.legal-story');
  if (!story) return;

  const copyButton = story.querySelector('[data-story-copy]');
  const copyStatus = story.querySelector('[data-story-copy-status]');
  copyButton?.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(window.location.href.split('#')[0]);
      copyStatus.textContent = 'Lien copié !';
    } catch (_) {
      copyStatus.textContent = 'La copie du lien est indisponible.';
    }
  });

  if (!story.classList.contains('legal-story--recipe')) return;
  const content = story.querySelector('.article-template-content');
  if (!content) return;

  const headings = [...content.querySelectorAll('h2')];
  const ingredients = headings.find((heading) => /ingr[ée]dients/i.test(heading.textContent));
  const preparation = headings.find((heading) => /comment pr[ée]parer|pr[ée]paration/i.test(heading.textContent));

  if (ingredients) {
    if (!ingredients.id) ingredients.id = 'ingredients';
    ingredients.classList.add('legal-story__ingredients-heading');
    let sibling = ingredients.nextElementSibling;
    while (sibling && sibling.tagName !== 'H2') {
      if (sibling.tagName === 'UL') {
        sibling.classList.add('legal-story__ingredients');
        break;
      }
      sibling = sibling.nextElementSibling;
    }
    const link = story.querySelector('[data-story-ingredients]');
    if (link) {
      link.href = `#${ingredients.id}`;
      link.hidden = false;
    }
    const jump = story.querySelector('[data-story-jump]');
    if (jump) jump.href = `#${ingredients.id}`;
  }

  if (preparation) {
    if (!preparation.id) preparation.id = 'preparation';
    preparation.classList.add('legal-story__preparation-heading');
    const link = story.querySelector('[data-story-preparation]');
    if (link) {
      link.href = `#${preparation.id}`;
      link.hidden = false;
    }
  }

  [...content.querySelectorAll('h3')]
    .filter((heading) => /^\s*[ée]tape\s*\d+/i.test(heading.textContent))
    .forEach((heading, index) => {
      heading.classList.add('legal-story__step');
      heading.dataset.step = String(index + 1).padStart(2, '0');
    });
})();
